import { CustomerId, ExternalTvConfig } from '@tivio/sdk-react'

import dvtvLogo from './images/dvtv-logo.png'
import garaz from './images/garaz.png'
import jojLogo from './images/joj-logo-color.png'
import mallLogo from './images/malltv-logo.png'
import oktagonLogo from './images/oktagon-logo.png'
import stargazeLogo from './images/stargaze-logo.png'
import starmaxLogo from './images/starmax-logo.png'


const appConfig: { [customer in CustomerId]?: ExternalTvConfig } = {
    [CustomerId.GARAZ]: {
        logo: garaz,
    },
    [CustomerId.JOJ]: {
        logo: jojLogo,
        splashScreenBackgroundColor: '#030414',
    },
    [CustomerId.MALL]: {
        logo: mallLogo,
    },
    [CustomerId.OKTAGON]: {
        logo: oktagonLogo,
    },
    [CustomerId.DVTV]: {
        logo: dvtvLogo,
    },
    [CustomerId.STARMAX]: {
        logo: starmaxLogo,
    },
    [CustomerId.STARGAZE]: {
        logo: stargazeLogo,
    },
}

export {
    appConfig,
}
